import { mapGetters } from 'vuex';
import utils from '@js/utils.js';
import cloneDeep from 'lodash.clonedeep';

export const componentMixin = {
	inject: ['emitter'],
	props: {
		scrolly: {
			type: Object
		},
		sectionId: {
			type: String
		},
		animate: {
			type: String,
			default: ''
		},
		sections: {
			type: Array
		},
		section: {
			type: Object
		}
	},
	data() {
		return {
			utils,
		}
	},
	computed: {
		...mapGetters(['isMobile']),
		sectionIndex() {
			return parseInt(this.sectionId.replace('s', ''))-1
		},
		animationPrefix() {
			return `[data-scrolly-id="${this.scrolly.id}"] #${this.sectionId}`
		},
	},
	methods: {
		openArtifactModal(artifact) {
			this.emitter.emit('open-artifact-modal', artifact)
		},
		showInDepth(sectionId) {
			this.emitter.emit('show-in-depth', sectionId)
		},
		selectMobileRemarkablePoint(obj) {
			this.emitter.emit('select-rm', obj)
		},
		closeMobileRemarkablePoint() {
			this.emitter.emit('close-rm', obj)
		},
	},
}
